<template>
  <div v-if="shoppingLists" class="shopping-lists-table">
    <table>
      <thead class="caption-semi-bold">
        <th>{{ tStatic('newShoppingListTableHeaderName') }}</th>
        <th>{{ tStatic('newShoppingListTableHeaderCreated') }}</th>
        <th>{{ tStatic('newShoppingListTableHeaderModified') }}</th>
        <th>{{ tStatic('newShoppingListTableHeaderCreatedBy') }}</th>
        <th>{{ tStatic('newShoppingListTableHeaderNumberOfRows') }}</th>
        <th></th>
      </thead>
      <tbody class="body-smaller">
        <tr v-if="!shoppingLists.length" class="shopping-lists-table__no-results">
          <td colspan="6">
            {{ tStatic('noShoppingLists') }}
          </td>
        </tr>
        <template v-for="(list, i) in shoppingLists">
          <tr :key="`${list.id}-${i}-row`">
            <td class="body-smaller-semi-bold" :data-label="tStatic('newShoppingListTableHeaderName')">
              {{ list.name }}
            </td>
            <td :data-label="tStatic('newShoppingListTableHeaderCreated')">
              {{ list.created }}
            </td>
            <td :data-label="tStatic('newShoppingListTableHeaderModified')">
              {{ list.modified }}
            </td>
            <td :data-label="tStatic('newShoppingListTableHeaderCreatedBy')">
              {{ list.createdByName || 'Saknas' }}
            </td>
            <td :data-label="tStatic('newShoppingListTableHeaderNumberOfRows')">
              {{ list.entries }}
            </td>
            <td>
              <button class="shopping-lists-table__open" @click="handleSelectShoppingList(list)">
                <oie-base-icon icon="chevron-right"></oie-base-icon>
              </button>
            </td>
          </tr>
          <tr
            v-if="!isLastRow(i)"
            :key="`${list.id}-${i}-spacer`"
            class="shopping-lists-table__spacer"
            aria-hidden="true">
            <td colspan="5"></td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import myPages from '@/mixins/my-pages'

export default {
  mixins: [myPages],
  props: {
    shoppingLists: {
      type: Array,
      required: false,
      default: null
    }
  },
  methods: {
    ...mapActions('myShoppingLists', ['selectShoppingList']),
    handleSelectShoppingList(list) {
      this.selectShoppingList(list.id)
      this.goToSubPage(this.navigationOptions.oieMyShoppingList)
    },
    isLastRow(i) {
      return i === this.shoppingLists.length - 1
    }
  }
}
</script>

<style lang="scss">
/*------------------------------------*\
    BASE
\*------------------------------------*/

.shopping-lists-table {
  overflow-y: auto;
}

.shopping-lists-table table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}

.shopping-lists-table th,
.shopping-lists-table td {
  padding: measure(half) measure(quarter);
  word-wrap: break-word;
}

/*------------------------------------*\
    HEAD
\*------------------------------------*/

.shopping-lists-table thead th {
  text-align: left;
}

/*------------------------------------*\
    BODY
\*------------------------------------*/

.shopping-lists-table tbody tr {
  position: relative;
  background-color: color(background-gray-5);
  border: 1px solid color(border-gray);
}

.shopping-lists-table tbody .shopping-lists-table__no-results {
  background-color: color(background-white);
  border: none;
}

.shopping-lists-table__open {
  @include reset-button;
}

.shopping-lists-table__open::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.shopping-lists-table tbody tr.shopping-lists-table__spacer {
  border: none;
}

.shopping-lists-table tbody tr.shopping-lists-table__spacer td{
  padding: measure(eighth) measure(quarter);
  background-color: color(background-white);
}

/*------------------------------------*\
    RESPONSIVE ADJUSTMENTS
\*------------------------------------*/

@include media(to-small) {
  .shopping-lists-table * {
    display: block;
  }

  .shopping-lists-table thead {
    display: none;
  }

  .shopping-lists-table td {
    padding-left: 50%;
    text-align: right;
  }

  .shopping-lists-table td::before {
    content: attr(data-label);
    position: absolute;
    left: 0;
    width: 50%;
    padding-left: measure(quarter);
    text-align: left;
  }

  .shopping-lists-table__open {
    margin-left: auto;
  }
}
</style>
